import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from "src/store/hooks";
import { queryParams } from "src/helpers/UrlHelpers";
import { fetchServerPlans } from "src/actions/mine_craft/serverPlansActions";
import { setNewParams } from "src/store/mine_craft/serverPlansSlice";

import PageLayout from '../_partials/PageLayout';
import PageHeader from "src/componets/PageHeader";
import Wrapper from "src/componets/Wrapper";
import NavBarThree from "src/componets/NavBarThree";
import Can from "src/componets/Can";
import ListViewButtons from "src/componets/ListViewButtons";
import { PlusOutlined } from "@ant-design/icons";

import List from "./_partials/_List";
import SidebarIndex from "./_partials/_SidebarIndex";
import New from "./New";
import Edit from "./Edit";
import './style.scss';

const LIMIT = 50;
const DEFAULT_VIEW = 'grid';

export interface PropsInterface {
  appId: 1 | 2;
}

const ServerPlans = ({ appId }: PropsInterface) => {
  const dispatch       = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage    = queryParams.getInt(searchParams, 'page') || 1;
  const listType: any  = queryParams.get(searchParams, 'view') || DEFAULT_VIEW;
  const { pathname }   = useLocation();

  useEffect(() => {
    const params: any = {
      app_id: appId,
      limit:  LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    dispatch(fetchServerPlans(params));
  }, [appId, pathname, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = {
      app_id:      appId,
      published:   false,
      featured:    false,
      coins:       0,
      memory_mb:   2048,
      disk_mb:     15360,
      cpu_percent: 100,
      max_players: 25
    };

    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-server-plans'>
      <PageHeader title='Server Plans' />

      <Can capability='write_minecraft'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Add Plan
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <ListViewButtons align='right' defaultType={DEFAULT_VIEW} />
        </Wrapper>

        <List limit={LIMIT} type={listType} />
      </div>

      <SidebarIndex />

      <New />
      <Edit />
    </PageLayout>
  );
}

export default ServerPlans;
